import $ from 'jquery'

export default () => {

  $(document).on('click', '.acardion__title', function openAcordion() {
    const thisItemParent = $(this).parent();
    if (thisItemParent.hasClass('active')) {
      thisItemParent.removeClass('active');
      thisItemParent.find('.acardion__inner').css('height', '0');
    } else {
      const itemHeight = thisItemParent.find('.acardion__content').outerHeight();
      $('.acardion__item').removeClass('active');
      $('.acardion__inner').css('height', '0');
      thisItemParent.addClass('active');
      thisItemParent.find('.acardion__inner').css('height', itemHeight);
    }
  })

  if (window.innerWidth < 767) {
    $('.footer-nav__title').on('click', function openCloseFooterMenu() {
      $(this).toggleClass('active')
      $(this).siblings('.footer-nav__list').slideToggle()
    })
  }

  function checklabels() {
    $('input, textarea').on('keyup change', function checkValueInputs() {
      if ($(this).val() !== '') {
        $(this).addClass('value');
      } else {
        $(this).removeClass('value');
      }
    })
    $('input, textarea').each(function eachInputs() {
      if ($(this).val() !== '') {
        $(this).addClass('value');
      } else {
        $(this).removeClass('value');
      }
    })
  }
  checklabels()

  $('.main-nav__opener').on('click', () => {
    $('.main-nav').toggleClass('active')
  })

  $('.main-nav__close').on('click', () => {
    $('.main-nav').removeClass('active')
  })

  $('.language__current').on('click', () => {
    $('.language__list').toggleClass('active')
  })

  $(document).on('click touchstart', (e) => {
    if (!$(e.target).closest('.language__current, .language__list').length) {
      $('.language__list').removeClass('active');
    }
    e.stopPropagation();
  });

  if (window.innerWidth < 768) {
    const loginButton = $('.login-button')
    const registerButton = $('.register-button')
    const lang = $('.language')

    $('.main-nav__buttons').append(loginButton)
    $('.main-nav__buttons').append(registerButton)
    $('.main-nav__language').html(lang)
  }

  $('.search__button').on('click', () => {
    $('.search__form').toggleClass('active')
  })

  $('.search__close').on('click', () => {
    $('.search__form').removeClass('active')
  })

  $(document).on('click touchstart', (e) => {
    if (!$(e.target).closest('.search__button, .search__form').length) {
      $('.search__form').removeClass('active');
    }
    e.stopPropagation();
  });

  $(window).on('scroll', () => {
    if ($(window).scrollTop() > 0) {
      $('.header').addClass('fixed')
    } else {
      $('.header').removeClass('fixed')
    }
  })

  if (window.innerWidth <= 1200) {
    $('.menu-item-has-children > a').on('click', function clickThis(e) {
      e.preventDefault();
      $(this).parent().toggleClass('active')
      const mainLinkText = $(this).html()
      const mainLinkHref = $(this).attr('href')
      $(this).siblings('.sub-menu').find('.main-cat').remove()
      $(this).siblings('.sub-menu').prepend(`<li class="main-cat"><a href="${mainLinkHref}">${mainLinkText}</a></li>`)
      $(this).siblings('.sub-menu').toggleClass('active')
    })
  }

  $('.menu-button').on('click', function openCloseMobileMenu(e) {
    e.preventDefault()
    $(this).toggleClass('active')
    $('.main-nav').toggleClass('active')
    $('body').toggleClass('holder-block')
  })

  let position = $(window).scrollTop()

  if (window.innerWidth <= 460) {
    $(window).scroll(() => {
      const scroll = $(window).scrollTop()
      if (scroll > position && $(window).scrollTop() > 30) {
        $('.mobile-menu').hide()
      } else {
        $('.mobile-menu').show()
      }
      position = scroll;
    })
  }
  
}


// WEBPACK FOOTER //
// app/scripts/components/main.js